import { Component, OnInit, Input } from '@angular/core';
import { UserApi } from 'src/app/models/api_models/user';

@Component({
  selector: 'app-user-sub-info',
  templateUrl: './user-sub-info.component.html',
  styleUrls: ['./user-sub-info.component.scss']
})
export class UserSubInfoComponent implements OnInit {

  private _user : UserApi = null;
  get user()  : UserApi {
    return this._user;
  }
  @Input()
  set user(user : UserApi) {
    this._user = user;
  }

  constructor() { }

  ngOnInit() {
  }

}
